import {Sensor} from '../../Common/Types/Sensor';
import {DeviceUtils} from '../../../common/util';
import {DeviceState} from '../../../common/constants';
import {PredictionService} from '../../../common/services';
import {OutUnit} from '../../../common/constants/OutUnit';

export async function predictiveAvailable(sensor: Sensor, orgId: string): Promise<[boolean, string]> {
	if (!DeviceUtils.IsLiberoGx(sensor)) return [false, 'Sensor is not a LIBERO Gx device'];

	if (sensor.IsRetired) return [false, 'Sensor is retired'];

	const requiredStates = [DeviceState.Transit, DeviceState.ConfigPending, DeviceState.Start];
	if (!requiredStates.find(s => s.toUpperCase() == sensor.LiberoGStateDescription.toUpperCase()))
		return [false, 'Sensor is not in required state'];

	if (sensor.OutUnitsId === OutUnit.RelHumidity) return [false, 'Sensor is not a temperature sensor'];

	try {
		const sensorPredictiveInformation = await PredictionService.GetSensorPredictiveInformation(orgId, sensor.Id);
		if (sensorPredictiveInformation) return [false, 'Sensor is already configured'];
	} catch (_) {
		return [false, 'elproPREDICT is currently not available. Please try again later.'];
	}

	return [true, ''];
}
